/**
 *  All api related to Favourites
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchMetaDefinitions(options = {}) {
  const params = options
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchCountries',
    () => source.cancel('fetchCountries: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'meta_definitions',
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ cacheChecksum, data }) => ({
      metaDefinitions: data.metaDefinitions,
      cacheChecksum: _.get(cacheChecksum, 'metaDefinitionsValue'),
    }))
}

// TODO: will implement when need to use
// export function fetchMetaDefinitionDynamicOptions(options) {
//   const { id, ...others } = options
//   const params = {
//     schemaVersion: '2020-02-01',
//     ...others
//   }

//   const source = CancelToken.source()
//   const requestOptions = {
//     endpoint: `meta_definitions/${id}/dynamic_options`,
//     params,
//     cancelToken: source.token
//   }

//   return {
//     promise: OmnitechApi
//       .request(requestOptions)
//       .then(res => res.data)
//       .then(({ data }) => ({
//         data: _.get(data, 'favourite', {})
//       }))
//       .catch(error => {
//         throw new Error(error)
//       }),
//     cancel: () => source.cancel('fetchMetaDefinitionDynamicOptions: Operation cancelled by user')
//   }
// }
